import React, { useState, useEffect } from 'react';

export default function Preloader() {
  const [hide, setHide] = useState(false);
  const [remove, setRemove] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setHide(true), 800);
    const timer2 = setTimeout(() => setRemove(true), 1600);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  if (remove) return null;

  return (
    <div className={`preloader${hide ? ' hide' : ''}`}>
      <div className="preloader-inner">
        <div className="loader-ring"></div>
        <img src="/images/logo.png" alt="RG Logo" className="preloader-logo" />
      </div>
    </div>
  );
}
